import {Component, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UsersService} from '../../../Services/users.service';

import {TranslateService} from '@ngx-translate/core';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {CountryService} from '../../../../translation/Services/Country.service';
import {Country} from '../../../../shared/Models/Country';
import {DeliveryContact} from '../../../Models/DeliveryContact';
import * as moment from 'moment';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-view-delivery-dealer',
  templateUrl: './view-delivery-dealer.component.html',
  styleUrls: ['./view-delivery-dealer.component.scss']
})
export class ViewDeliveryDealerComponent implements OnInit {
  public invoiceDealerId: number;
  public enableSave = true;
  public deliveryUserId: number;
  public deliveryDealer: SystemUser = new SystemUser();
  public classicBox;
  public lastValue = <any>{};
  public archive = false;
  public userId = false;
  public userFullname = false;
  public employees: any;
  public editingUser;
  public cloneEditingUser;
  public refreshModal;
  public showManageDealerUser = false;
  public manageProfile;
  public users: SystemUser[] = [];
  public editDeliveryContact = false;
  public countries: Country[] = [];
  public deliveryContact: DeliveryContact;
  public contactInformation: DeliveryContact;
  public dealerUser: any;
  @ViewChild('usersRowDetail', {static: false}) usersRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('readdModal', {static: false}) readdModal = null;
  @ViewChild('editPointModal', {static: false}) editPointModal = null;
  @ViewChild('deliveryContactModal', {static: false}) deliveryContactModal = null;
  @ViewChild('addNewDeliveryContact', {static: false}) addNewDeliveryContact: NgForm;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private deliveryDealersService: UsersService,
              private translateService: TranslateService,
              private broadcastService: BroadcastService,
              private  countryService: CountryService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['deliveryId'])) {
        this.invoiceDealerId = params['id'];
        this.deliveryUserId = params['deliveryId'];
        this.getDeliveryDealerItem();
        this.getCountries();
        this.deliveryContact = new DeliveryContact();
      }
    });

    this.classicBox = <FormlyFieldConfig>[
      {
        fieldGroupClassName: 'row',
        key: 'user',
        fieldGroup: [
          {
            className: 'col-12 ',
            type: 'input',
            key: 'dealerPoints',
            templateOptions: {
              label: this.translateService.instant('doctrine.user.dealer_points'),
              required: true,
              pattern: '^(\\+|-)?\\d+$',
              maxLength: environment.maxStringLength,
            },
            validation: {
              messages: {
                pattern: this.translateService.instant('errors.invalid'),
                required: this.translateService.instant('errors.required'),
                maxlength: (error, field: FormlyFieldConfig) =>
                  this.translateService.instant('validators.max_message', {limit: field.templateOptions.maxLength})
              }
            }
          }
        ]
      }
    ];
  }


  getDeliveryDealerItem() {
    this.deliveryDealersService.getDealerUser(this.deliveryUserId).subscribe((resp) => {
      if (resp) {
        this.users = [];
        this.deliveryDealer = resp;
        this.users.push(this.deliveryDealer);
        if (this.deliveryDealer.employee) {
          this.deliveryDealer.employee.forEach(user => {
            this.users.push(user);
          });
        }
        this.lastValue = {user: resp};
        this.dealerUser = Object.assign({}, this.lastValue.user);
        if (this.deliveryDealer.deliveryContact) {
          this.contactInformation = Object.assign({}, this.deliveryDealer.deliveryContact);
          this.editDeliveryContact = true;
        } else {
          this.contactInformation = new DeliveryContact();

        }
        return;
      }
      this.router.navigateByUrl('/back-office/crm/dealer/overview');
    });
  }

  setDeliveryContact() {
    if (this.deliveryDealer.deliveryContact) {
      this.deliveryContact = Object.assign({}, this.deliveryDealer.deliveryContact);
      this.deliveryContact.country = this.deliveryContact.country.id;
      this.setWeeklyTime();
      this.editDeliveryContact = true;
    } else {
      this.deliveryContact = new DeliveryContact();
    }
  }

  setWeeklyTime() {
    if (this.deliveryContact.mondayFrom) {
      const mondayFrom = new Date();
      mondayFrom.setTime(Date.parse(this.deliveryContact.mondayFrom));
      this.deliveryContact.mondayFrom = {
        hour: mondayFrom.getUTCHours(),
        minute: mondayFrom.getUTCMinutes(),
        second: 0
      };
    }
    if (this.deliveryContact.mondayTo) {
      const mondayTo = new Date();
      mondayTo.setTime(Date.parse(this.deliveryContact.mondayTo));
      this.deliveryContact.mondayTo = {
        hour: mondayTo.getUTCHours(),
        minute: mondayTo.getUTCMinutes(),
        second: 0
      };
    }
    if (this.deliveryContact.tuesdayFrom) {
      const tuesdayFrom = new Date();
      tuesdayFrom.setTime(Date.parse(this.deliveryContact.tuesdayFrom));
      this.deliveryContact.tuesdayFrom = {
        hour: tuesdayFrom.getUTCHours(),
        minute: tuesdayFrom.getUTCMinutes(),
        second: 0
      };
    }
    if (this.deliveryContact.tuesdayTo) {
      const tuesdayTo = new Date();
      tuesdayTo.setTime(Date.parse(this.deliveryContact.tuesdayTo));
      this.deliveryContact.tuesdayTo = {
        hour: tuesdayTo.getUTCHours(),
        minute: tuesdayTo.getUTCMinutes(),
        second: 0
      };
    }

    if (this.deliveryContact.wednesdayFrom) {
      const wednesdayFrom = new Date();
      wednesdayFrom.setTime(Date.parse(this.deliveryContact.wednesdayFrom));
      this.deliveryContact.wednesdayFrom = {
        hour: wednesdayFrom.getUTCHours(),
        minute: wednesdayFrom.getUTCMinutes(),
        second: 0
      };
    }

    if (this.deliveryContact.wednesdayTo) {
      const wednesdayTo = new Date();
      wednesdayTo.setTime(Date.parse(this.deliveryContact.wednesdayTo));
      this.deliveryContact.wednesdayTo = {
        hour: wednesdayTo.getUTCHours(),
        minute: wednesdayTo.getUTCMinutes(),
        second: 0
      };
    }
    if (this.deliveryContact.thursdayFrom) {
      const thursdayFrom = new Date();
      thursdayFrom.setTime(Date.parse(this.deliveryContact.thursdayFrom));
      this.deliveryContact.thursdayFrom = {
        hour: thursdayFrom.getUTCHours(),
        minute: thursdayFrom.getUTCMinutes(),
        second: 0
      };
    }

    if (this.deliveryContact.thursdayTo) {
      const thursdayTo = new Date();
      thursdayTo.setTime(Date.parse(this.deliveryContact.thursdayTo));
      this.deliveryContact.thursdayTo = {
        hour: thursdayTo.getUTCHours(),
        minute: thursdayTo.getUTCMinutes(),
        second: 0
      };
    }

    if (this.deliveryContact.fridayFrom) {
      const fridayFrom = new Date();
      fridayFrom.setTime(Date.parse(this.deliveryContact.fridayFrom));
      this.deliveryContact.fridayFrom = {
        hour: fridayFrom.getUTCHours(),
        minute: fridayFrom.getUTCMinutes(),
        second: 0
      };
    }

    if (this.deliveryContact.fridayTo) {
      const fridayTo = new Date();
      fridayTo.setTime(Date.parse(this.deliveryContact.fridayTo));
      this.deliveryContact.fridayTo = {
        hour: fridayTo.getUTCHours(),
        minute: fridayTo.getUTCMinutes(),
        second: 0
      };
    }
  }

  getCountries() {
    this.countryService.list().subscribe(resp => {
      this.countries = resp.data;
    });
  }

  getDeliveryDealer() {
    return SystemUser;
  }

  showDeleteModal(id, name) {
    this.userId = id;
    this.userFullname = name;
    this.deleteModal.show();
  }

  softDelete() {
    this.deliveryDealersService.softDeleteEmployeeUser(this.userId).subscribe((res) => {
      this.deleteModal.hide();
      this.getDeliveryDealerItem();
    });
  }

  switchShowArchive() {
    this.archive = !this.archive;
    if (this.archive) {
      this.showDeliveryDealerUsersArchive();
    } else {
      this.getDeliveryDealerItem();
    }
  }

  showDeliveryDealerUsersArchive() {
    // this.deliveryDealersService.getEmployeeUserArchive(this.deliveryUserId).subscribe((res) => {
    //   this.employees = res;
    //   this.users = this.employees;
    // });
  }

  showReaddModal(id, name) {
    this.userId = id;
    this.userFullname = name;
    this.readdModal.show();
  }

  readDealerUser() {
    this.deliveryDealersService.readdEmployeeUser(this.userId).subscribe((res) => {
      this.readdModal.hide();
      this.showDeliveryDealerUsersArchive();
    });
  }

  saveDealerPoint() {
    const user = {dealerPoints: this.lastValue.user.dealerPoints};
    this.deliveryDealersService.updateDealerPoint(user, this.deliveryUserId).subscribe((resp) => {
      this.getDeliveryDealerItem();
      this.editPointModal.hide();
    });
  }

  showEditPoints() {
    this.editPointModal.show();
  }

  enableButton(event) {
    this.enableSave = event;
  }

  ManageUserModal(user, manageUser: boolean) {

    this.showManageDealerUser = true;


  }

  openManageUserModal(delivery, isManageProfile) {
    if (delivery === null || delivery.role.name !== 'admin.dealer.role.admin') {
      this.refreshModal = Math.random();
      this.editingUser = Object.assign({}, delivery);
      this.showManageDealerUser = true;
    } else {
      this.router.navigateByUrl('back-office/crm/dealer/' + delivery.invoiceDealer.id + '/delivery/' + delivery.id);
    }
  }


  refreshGrid($event) {
    this.getDeliveryDealerItem();
  }

  showAddDeliveryContactModal() {
    this.setDeliveryContact();
    this.deliveryContactModal.show();
  }

  manageDeliveryContact() {
    this.deliveryContact.mondayFrom = this.deliveryContact.mondayFrom ? moment(this.deliveryContact.mondayFrom).format('HH:mm') : null;
    this.deliveryContact.mondayTo = this.deliveryContact.mondayTo ? moment(this.deliveryContact.mondayTo).format('HH:mm') : null;
    this.deliveryContact.tuesdayFrom = this.deliveryContact.tuesdayFrom ? moment(this.deliveryContact.tuesdayFrom).format('HH:mm') : null;
    this.deliveryContact.tuesdayTo = this.deliveryContact.tuesdayTo ? moment(this.deliveryContact.tuesdayTo).format('HH:mm') : null;
    this.deliveryContact.wednesdayFrom = this.deliveryContact.wednesdayFrom ? moment(this.deliveryContact.wednesdayFrom).format('HH:mm') : null;
    this.deliveryContact.wednesdayTo = this.deliveryContact.wednesdayTo ? moment(this.deliveryContact.wednesdayTo).format('HH:mm') : null;
    this.deliveryContact.thursdayFrom = this.deliveryContact.thursdayFrom ? moment(this.deliveryContact.thursdayFrom).format('HH:mm') : null;
    this.deliveryContact.thursdayTo = this.deliveryContact.thursdayTo ? moment(this.deliveryContact.thursdayTo).format('HH:mm') : null;
    this.deliveryContact.fridayFrom = this.deliveryContact.fridayFrom ? moment(this.deliveryContact.fridayFrom).format('HH:mm') : null;
    this.deliveryContact.fridayTo = this.deliveryContact.fridayTo ? moment(this.deliveryContact.fridayTo).format('HH:mm') : null;

    this.deliveryContact.deliveryDealer = this.deliveryUserId;
    let id = null;
    if (this.editDeliveryContact) {
      id = this.deliveryContact.id;
      delete this.deliveryContact.id;
    }
    this.deliveryDealersService.manageDeliveryContact(this.deliveryContact, this.editDeliveryContact, id).subscribe((res) => {
      this.deliveryContactModal.hide();
      this.getDeliveryDealerItem();
    });
  }

  hideDeliveryContactModal() {
    this.deliveryContactModal.hide();
    this.addNewDeliveryContact.reset();
  }
}
